export default "__VITE_ASSET__Bo5g7fBQ__"